module.exports = __webpack_public_path__ + "dash_20_app_assets/img/feedbackdone.cc054dd4.png";